import React, { useMemo } from 'react';

import type { TableWidgetData } from '@/features/_shared/widget-registry';
import { useMarketPreview } from '@/features/Markets/api';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { Box } from '@/shared/ui/layout/Box';

// MarketsComponents and PageInformationContext are not yet in their target feature path.
// TODO: update these imports once Markets and app/context are fully migrated.
// eslint-disable-next-line no-restricted-imports
import { PageInformationContext } from '@/context/PageInformationContext';
// eslint-disable-next-line no-restricted-imports
import MarketsComponents from '@/pages/Markets/MarketsComponents';

import type { MarketApps } from '@/features/Dashboard/types';

export function buildTemplate(data: TableWidgetData): MarketApps {
  return [
    {
      id: `ai-chat-apps-${data.tool_call_id}`,
      tabs: [
        {
          id: `ai-chat-table-${data.tool_call_id}`,
          name: 'Data Table',
          type: 'table',
          metadata: {
            start_date: data.metadata?.start_date ?? '',
            end_date: data.metadata?.end_date ?? ''
          },
          sections: [
            {
              name: '',
              rows: data.rows.map(row => ({
                shortTitle: row.title,
                symbol: {
                  key: {
                    Code: row.code,
                    PeriodType: row.period_type,
                    Period: '1',
                    TimeRef: row.time_ref?.toString() ?? ''
                  },
                  group: 'Prod_Indexes'
                },
                diffSymbol: {
                  key: { Code: '', PeriodType: '', Period: '', TimeRef: '' },
                  group: 'Prod_Indexes'
                }
              }))
            }
          ]
        }
      ]
    }
  ];
}

export const MarketPreviewWidget = React.memo(({ data }: { data: TableWidgetData }) => {
  const template = useMemo(() => buildTemplate(data), [data]);
  const { data: previewData, isLoading } = useMarketPreview(template);

  return (
    <PageInformationContext value={{ mainPageTitle: 'AI Chat' }}>
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <Spinner
            centered={false}
            size={24}
          />
        </Box>
      ) : (
        previewData && (
          <MarketsComponents
            forChat
            showAddToDashboard
            components={previewData.components}
            showShareBlock={false}
          />
        )
      )}
    </PageInformationContext>
  );
});

MarketPreviewWidget.displayName = 'MarketPreviewWidget';
